import { Action, createReducer, on } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

import * as sectionActions from './sections.actions';
import { Section } from 'src/app/models/section';

export interface SectionState extends EntityState<Section> {
  loadingSections: boolean;
  sectionsLoaded: boolean;
  loadingSection: boolean;
  sectionLoaded: boolean;
  sectionsSortingOrder: number[];
  selectedSection: Section;
}

export const sectionAdapter: EntityAdapter<Section> = createEntityAdapter<Section>({});

export const initialSectionState: SectionState = sectionAdapter.getInitialState({
  loadingSections: false,
  sectionsLoaded: false,
  loadingSection: false,
  sectionLoaded: false,
  sectionsSortingOrder: [],
  selectedSection: null,
});

export const reducer = createReducer(
  initialSectionState,
  on(sectionActions.getSections, (state) => {
    return {
      ...state,
      loadingSections: true,
      sectionsLoaded: false,
    };
  }),
  on(sectionActions.getSectionsSuccess, (state, { sections }) => {
    return sectionAdapter.setAll(sections, {
      ...state,
      loadingSections: false,
      sectionsLoaded: true,
    });
  }),
  on(sectionActions.getSectionsError, (state) => {
    return {
      ...state,
      loadingSections: false,
      sectionsLoaded: false,
    };
  }),
  on(sectionActions.getSection, (state) => {
    return {
      ...state,
      loadingSection: true,
      sectionLoaded: false,
    };
  }),
  on(sectionActions.getSectionSuccess, (state, { selectedSection }) => {
    return {
      ...state,
      loadingSection: false,
      sectionLoaded: true,
      selectedSection,
    };
  }),
  on(sectionActions.getSectionError, (state) => {
    return {
      ...state,
      loadingSection: false,
      sectionLoaded: false,
      selectedSection: null,
    };
  }),
  on(sectionActions.saveSectionsSortingOrderSuccess, (state, { sortingOrder }) => {
    return {
      ...state,
      sectionsSortingOrder: sortingOrder,
    };
  }),
  on(sectionActions.setSelectedSection, (state, { selectedSection }) => {
    return {
      ...state,
      loadingSection: false,
      sectionLoaded: true,
      selectedSection,
    };
  }),
  on(sectionActions.createSectionSuccess, (state, { createdSection }) => {
    return sectionAdapter.addOne(createdSection, {
      ...state,
      selectedSection: createdSection,
    });
  }),
  on(sectionActions.updateSectionSuccess, (state, { updatedSection }) => {
    return sectionAdapter.updateOne(
      { id: updatedSection?.id, changes: updatedSection },
      {
        ...state,
        selectedSection: updatedSection,
      }
    );
  }),
  on(sectionActions.deleteSectionSuccess, (state, { deletedSection }) => {
    return sectionAdapter.removeOne(deletedSection.id, {
      ...state,
    });
  })
);

export function SectionReducer(state: SectionState | undefined, action: Action) {
  return reducer(state, action);
}

export const { selectIds, selectEntities, selectAll, selectTotal } = sectionAdapter.getSelectors();
